<template>
  <div class="th-tag-input">
    <div class="th-tag-chips">
      <span class="th-tag-chip" v-for="t in value" :key="t">
        #{{ t }}
        <i class="el-icon-close" @click="removeTag(t)" />
      </span>
      <input
        class="th-tag-field"
        v-model="draft"
        :maxlength="50"
        :placeholder="value.length ? '' : $t('happilyVillage.reels.add_tag')"
        @keydown.enter.prevent="commitDraft"
        @keydown.188.prevent="commitDraft"
        @keydown.space.prevent="commitDraft"
      />
      <span class="th-tag-count">{{ value.length }}/{{ max }}</span>
    </div>
    <div class="th-tag-suggestions" v-if="suggestions.length">
      <span class="th-tag-suggestion" v-for="s in suggestions" :key="s.name" @click="pick(s.name)">#{{ s.name }}</span>
    </div>
  </div>
</template>

<script>
import { addTag, mergeTagSuggestions } from './inbox-logic'

export default {
  name: 'TownHallTagInput',
  props: {
    value: { type: Array, default: () => [] },
    suggestionsDoc: { type: Object, default: () => ({ tags: {} }) },
    max: { type: Number, default: 10 },
  },
  data() {
    return { draft: '' }
  },
  computed: {
    suggestions() {
      const all = mergeTagSuggestions(this.suggestionsDoc, undefined, 8)
      return all.filter(s => !this.value.includes(s.name)).slice(0, 6)
    },
  },
  methods: {
    commitDraft() {
      const next = addTag(this.value, this.draft, this.max)
      this.draft = ''
      if (next !== this.value) this.$emit('input', next)
    },
    pick(name) {
      const next = addTag(this.value, name, this.max)
      if (next !== this.value) this.$emit('input', next)
    },
    removeTag(t) {
      this.$emit('input', this.value.filter(x => x !== t))
    },
  },
}
</script>

<style scoped>
.th-tag-chips { display: flex; flex-wrap: wrap; align-items: center; gap: 6px; border: 1px solid #e2e4ea; border-radius: 8px; padding: 8px 10px; min-height: 40px; }
.th-tag-chip { display: inline-flex; align-items: center; gap: 4px; padding: 2px 9px; border-radius: 999px; background: #f2ecfb; color: #6c30cc; font-size: 12px; font-weight: 700; }
.th-tag-chip .el-icon-close { cursor: pointer; font-size: 12px; }
.th-tag-field { border: none; outline: none; flex: 1; min-width: 80px; font-size: 13px; }
.th-tag-count { font-size: 11px; color: #8a8a8a; font-weight: 700; }
.th-tag-suggestions { display: flex; flex-wrap: wrap; gap: 6px; margin-top: 8px; }
.th-tag-suggestion { padding: 3px 10px; border-radius: 999px; background: #fafbfc; border: 1px solid #e2e4ea; color: #626262; font-size: 12px; font-weight: 700; cursor: pointer; }
</style>
